import React, { forwardRef } from 'react';
import icons from '@capsovision/capso_utils/iconpack/symbol-defs.svg';
import './CapsoIcon.css';

const CapsoIcon = forwardRef((props, ref) => {

	const { iconName, size, grey, ...rest } = props;

	return (
		<React.Fragment>
			<svg
				className={`capso-icon ${size} ${grey ? 'grey' : ''}`}
				ref={ref}
				data-grey={grey ? 'true' : 'false'}
				{...rest}
			>
				<use xlinkHref={`${icons}#icon-${iconName}`}></use>
			</svg>
		</React.Fragment>
	)
})

CapsoIcon.displayName = 'CapsoIcon';

export default CapsoIcon;